module.exports = __webpack_public_path__ + "static/media/overlay3.8bc69f61.png";